export default __webpack_public_path__ + "static/img/ticket-female.b234b29.png";